<template>
  <fieldset class="form-item-checkboxes">
    <legend>{{ element.metadata?.title }}</legend>
    <div v-for="option in element.options" :key="option?.value" class="form-item-checkboxes__group" :class="{'form-item-checkboxes__group--error' : hasErrors }">
      <input
        :id="`${element.metadata?.key}${option?.value}`"
        :value="option?.value"
        :name="`${element.metadata?.key}`"
        type="checkbox"
      >
      <label :for="`${element.metadata?.key}${option?.value}`">{{ option?.title }}</label>
    </div>
    <FormItemErrors :element="element" :form-errors="formErrors" />
  </fieldset>
</template>
<script setup lang="ts">
import FormItemErrors from './FormItemErrors.vue'
import { type WebformElementOptionsBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

const props = defineProps<{
  element: WebformElementOptionsBaseFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()

const hasErrors = computed(() =>
  useFormItemHasError(props.formErrors, props.element.metadata?.key)
)

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-checkboxes {
  @include tools.fieldset;

  &__group {
    @include tools.form-group-checkbox;

    &--error {
      @include tools.form-group-checkbox-error;
    }
  }
}
</style>
